import React from 'react';

import Ionicons from '@expo/vector-icons/Ionicons';
import { Image, makeUclComponent } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';
import { withTypography } from 'ucl/components/text/Typography';

import ActionButton from 'components/action-button';
import { Box, BoxProps } from 'components/ui';
import { primitive, spacing } from 'styles/constants';

export const Title = withTypography({
  fontSize: 'lg',
  color: primitive.$white,
  bold: true,
});

export const RetakeText = withTypography({
  fontSize: 12,
  color: primitive.$white,
  bold: true,
  style: { justifyContent: 'center' },
});

export const CustomButton = makeUclComponent(ActionButton).withConfig({
  fullWidth: false,
  letterSpacing: '0.5px',
  padding: '$1',
  paddingX: '$3',
  backgroundColor: primitive.$black,
  _text: {
    fontSize: 12,
    color: primitive.$white,
  },
});

export const SubmitYourPhotoButton = makeUclComponent(ActionButton).withConfig({
  width: 300,
  margin: 'auto',
  bottom: 3,
});

export const RetakeButton = CustomButton.withConfig({
  borderColor: primitive.$white,
  borderWidth: '2px',
  height: 30,
});

export const TopBar = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.topBar, style] });

export const PromptTextContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.promptTextContainer, style] });

export const PromptText = withTypography({
  color: primitive.$white,
  fontSize: 'xl',
  bold: true,
});

export const CameraIcons = makeUclComponent(Ionicons).withConfig({
  fontSize: 28,
  color: primitive.$white,
});

export const OverlayContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.overlayContainer, style] });

export const CameraInstructionPopup = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.cameraInstructionPopup, style] });

export const CameraInstructionText = withTypography({
  color: '#5A3625',
  bold: true,
  fontSize: 'lg',
  textAlign: 'center',
});

export const ImageOverlayContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    pointerEvents: 'none',
    style: [styles.imageOverlayContainer, style],
  });

export const ImageOverlay = Image.withConfig({
  width: '100%',
  height: '100%',
  position: 'absolute',
  top: 0,
  left: 0,
  zIndex: 10,
});

const styles = StyleSheet.create({
  topBar: {
    alignItems: 'center',
    backgroundColor: primitive.$black,
    flexDirection: 'row',
    justifyContent: 'space-between',
    left: 0,
    paddingHorizontal: spacing.$2,
    right: 0,
    width: '100%',
    zIndex: 10,
  },
  promptTextContainer: {
    alignItems: 'center',
    backgroundColor: 'rgba(0,0,0,0.2)',
    bottom: 0,
    left: 0,
    paddingVertical: spacing.$4,
    position: 'absolute',
    right: 0,
  },
  overlayContainer: {
    alignItems: 'center',
    backgroundColor: primitive.$blackOpacity20,
    bottom: 0,
    height: '100%',
    left: 0,
    paddingVertical: spacing.$4,
    position: 'absolute',
    right: 0,
    width: '100%',
    zIndex: 10,
  },
  cameraInstructionPopup: {
    alignSelf: 'center',
    backgroundColor: primitive.$white,
    borderRadius: 16,
    elevation: 4,
    maxWidth: '90%',
    paddingHorizontal: spacing.$6,
    paddingVertical: spacing.$4,
    position: 'absolute',
    shadowColor: primitive.$black,
    shadowOpacity: 0.2,
    shadowRadius: 4,
    top: spacing.$2,
    zIndex: 999,
  },
  imageOverlayContainer: {
    alignItems: 'center',
    bottom: 0,
    left: 0,
    position: 'absolute',
    right: 0,
    zIndex: 2,
  },
});
